import React, { useMemo, useRef, useState } from "react";
import { RCCRefModalProps } from "react-common-components";

import DeleteModal from "src/components/DeleteModal";
import {ConfirmModalContext} from "./context";

const ConfirmModalProvider: React.FC = ({children}) => {
	const modalConfirm = useRef<RCCRefModalProps>(null);
	const [titleCtx, setTitle] = useState("");
	const [descriptionCtx, setDescription] = useState("");
	const [isDelete, setIsDelete] = useState(false);
	const [onSubmitCtx, setOnSubmit] = useState<Function | undefined>(undefined);
	const onCloseCtx = useRef<Function>(() => {});

	const confirm = async (title: string, description: string, onSubmit: Function, onError: Function, isDeleteModal: boolean = false, onClose?: Function) => {
		setTitle(title);
		setDescription(description);
		setIsDelete(isDeleteModal);
		setOnSubmit(() => async () => {
			try{
				modalConfirm.current?.setLoadingButton();
				await onSubmit();
				modalConfirm.current?.resetLoadingButton();
				modalConfirm.current?.closeModal();
			}catch(err){
				modalConfirm.current?.resetLoadingButton();
				onError(err);
			}
		});
		onCloseCtx.current = onClose || (() => {});
		modalConfirm.current?.openModal();
	};

	const ConfirmModalComponent = useMemo(() => <ConfirmModalContext.Provider value={{confirm}}>
		{children}
	</ConfirmModalContext.Provider>, []);

	return (
		<>
			{ConfirmModalComponent}
			<DeleteModal 
				ref={modalConfirm}
				title={titleCtx}
				description={descriptionCtx}
				isInfo={!isDelete}
				onSubmit={onSubmitCtx ? () => onSubmitCtx() : undefined}
				onClose={() => onCloseCtx.current()}
			/>
		</>
	);
};

export default ConfirmModalProvider;
